import { render, staticRenderFns } from "./groupDeital.vue?vue&type=template&id=c79b3e5a"
import script from "./groupDeital.vue?vue&type=script&lang=js"
export * from "./groupDeital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports